import appSettings from '../config/settings';

const transitions = new Map();
const getMetricsStore = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!window.__navigationMetrics) {
    window.__navigationMetrics = [];
  }

  return window.__navigationMetrics;
};

const now = () =>
  typeof window !== 'undefined' && window.performance?.now ? window.performance.now() : Date.now();

const round = value => Math.round(value * 10) / 10;
const shouldLog =
  appSettings.dev ||
  (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));

export const startNavigationInstrumentation = ({ transitionId, pathname }) => {
  transitions.set(transitionId, {
    pathname,
    startedAt: now(),
  });
};

export const markNavigationStage = (transitionId, stage) => {
  const entry = transitions.get(transitionId);
  if (!entry) {
    return;
  }

  entry[stage] = now();
};

export const finishNavigationInstrumentation = transitionId => {
  const entry = transitions.get(transitionId);
  if (!entry) {
    return null;
  }

  const finishedAt = now();
  const totalDuration = finishedAt - entry.startedAt;
  const dataLoadDuration =
    typeof entry.dataReadyAt === 'number' ? entry.dataReadyAt - entry.startedAt : null;
  const chunkLoadDuration =
    typeof entry.chunkReadyAt === 'number' ? entry.chunkReadyAt - entry.startedAt : null;

  const summary = {
    pathname: entry.pathname,
    totalDuration: round(totalDuration),
    dataLoadDuration: dataLoadDuration == null ? null : round(dataLoadDuration),
    chunkLoadDuration: chunkLoadDuration == null ? null : round(chunkLoadDuration),
  };

  const metricsStore = getMetricsStore();
  if (metricsStore) {
    metricsStore.unshift(summary);
    if (metricsStore.length > 30) {
      metricsStore.length = 30;
    }
  }

  if (shouldLog) {
    console.warn('[navigation]', summary);
  }

  transitions.delete(transitionId);
  return summary;
};
